import complaint_handling from "assets/images/complaint_handling_procedure.png";
export const branchLocation = [
  {
    name: "KL Main Branch",
    phoneNo: "03-2301 7094",
    type: "WITHIN",
    addreess:
      "Ground Floor, Mezzanine & Basement 1, East Block, Wisma Golden Eagle Realty, No 142-B, Jalan Ampang, 50450 Kuala Lumpur",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Bangsar Affluent Branch",
    phoneNo: "03-2858 0500",
    type: "WITHIN",
    addreess:
      "Bangsar Affluent Branch Lot No.G02 (East Wing), Ground Floor BRDB Tower Bangsar Shopping Centre, 59000 Bangsar, Kuala Lumpur",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+bangsar&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Shah Alam Branch",
    phoneNo: "03-5886 3300",
    type: "WITHIN",
    addreess:
      "Shah Alam Branch Ground Floor, No. 2, Jalan Tengku Ampuan Zabedah 9/A,40100 Shah Alam, Selangor",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+shah+alam&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Kota Damansara Branch",
    phoneNo: "03-5886 3300",
    type: "WITHIN",
    addreess:
      "No.28 Ground Floor, Jalan PJU 5/17, Dataran Sunway, Kota Damansara, 47810 Petaling Jaya, Selangor",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+kota+damansara&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Ipoh Branch",
    phoneNo: "05-618 2200",
    type: "OUTSIDE",
    addreess:
      "GA-E-02 & GA-E-02A, Ground & 1st Floor, Persiaran Greentown 4C, Pusat Perdagangan Greentown, 30450 Ipoh, Perak Darul Ridzuan.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+ipoh&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Johor Bahru Branch",
    phoneNo: "07-287 9800",
    type: "OUTSIDE",
    addreess:
      "33, Jalan Molek 2/4, Taman Molek, 81100 Johor Bahru, Johor Darul Takzim.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+johor+bahru&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Kota Bharu Branch",
    phoneNo: "09-738 1100",
    type: "OUTSIDE",
    addreess:
      "Wisma Aminah Zain, Lot 320, Seksyen 21, Jalan Sultan Yahya Petra, 15150 Kota Bharu, Kelantan.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+kota+bharu&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Kota Kinabalu Branch",
    phoneNo: "088-960 400",
    type: "OUTSIDE",
    addreess:
      "Lot 5, 6 & 7, Ground Floor, Wisma Muis, Peti Surat 11666, 88818 Kota Kinabalu, Sabah.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+kota+kinabalu&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Kuantan Branch",
    phoneNo: "09-509 1200",
    type: "OUTSIDE",
    addreess: "No. A51, Jalan Tun Ismail 1, Kuantan Perdana, 25000 Pahang.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+kuantan&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Kuching Branch",
    phoneNo: "082-405 000",
    type: "OUTSIDE",
    addreess:
      "BT 136, Ground Floor, Block B, ICOM Square, Section 64 KTLD, Jalan Pending, Kuching Sarawak",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+kuching&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Melaka Branch",
    phoneNo: "06-240 1380",
    type: "OUTSIDE",
    addreess: "336, Jalan Melaka Raya 1, Taman Melaka Raya, 75000 Melaka.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+melaka&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Penang Branch",
    phoneNo: "04-510 6500",
    type: "OUTSIDE",
    addreess: "18-G-A, Menara Gurney, Jalan Kelawai, 10350 Penang.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+penang&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Sungai Petani Branch",
    phoneNo: "04-410 6600",
    type: "OUTSIDE",
    addreess:
      "77, Ground & 1st Floor, Jalan Lagenda 1, Lagenda Heights, 08000 Sungai Petani, Kedah Darul Aman.",
    src: "https://www.google.com/maps/embed/v1/place?q=al+rajhi+bank+sungai+petani&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
  {
    name: "Vestland Commercial Centre",
    phoneNo: "04-410 6600",
    type: "ATM",
    addreess:
      "ATM-01, Ground Floor, No. 6,Jalan Juruanalisis U1/35, Seksyen U1, Shah Alam, Selangor.",
    src: "https://www.google.com/maps/embed/v1/place?q=vestland+commercial+center&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8",
  },
];

export const accordionItems = [
  {
    title: "<h1>Feedback & <span>Complaints</span></h1>",
    content: `
    <p>
    Customer satisfaction is important to us as we strive to provide the best possible services at all times. We value
    your feedback as they assist us to improve our products, services and customer service.
    <br /><br />
    <b>We want to hear from you</b>
    <br /><br />
    We would love to hear about positive experiences you have had with us. If we have delighted you and you would like
    to drop us a line:
    <br />
<ul>
    <li>Email us at customersupport@alrajhibank.com.my</li>
</ul>
<br />
<b>How a complaint can be made</b>
<br /><br />
If you are dissatisfied with the service provided by us, you may in the first instance consider speaking directly with
the staff member/s you have been dealing with. If you are uncomfortable with this or consider the staff member is unable
to address your concerns, you can lodge a complaint with us in one of the following ways:
<br /><br />
<ul>
    <li>By calling our Customer Resolution at +603 2332 6000</li>
    <li>By writing to us :<br />
        Manager, Customer Resolution
        Level 17 Menara Chan<br />
        138 Jalan Ampang<br />
        50450 Kuala Lumpur<br />
    </li>
    <li>By emailing us the<br />
        Complaint Form: customer.resolution@alrajhibank.com.my<br />
    </li>
    <li>
        In person by speaking to any of our customer service staff
    </li>
</ul>
<br />
<b>The information you will need to tell us</b>
<br /><br />
When we investigate your complaint, we will be relying on information provided by you. We may need to contact you to
clarify details or request additional information, where necessary. To help us investigate your complaint promptly and
efficiently we will ask you for the following information:
<br />
<ul>
    <li>
        Your full name and contact details;
    </li>
    <li>
        The name of the person you have been dealing with, if applicable;
    </li>
    <li>Information about the complaint (excluding numbers and sensitive account information);
    </li>
    <li>Details of conversations you may have had with us that may be relevant to your complaint;
    </li>
    <li>Copies of documentations (if any) which supports your complaint
    </li>
</ul>

<br />
Note : For your security, please do not provide any confidential or personal account information.
<br />
Help when making a complaint
<br />
The person receiving or managing your complaint should provide you with any assistance you may need to make your
complaint. However, should you need further assistance please contact our Customer Care Consultant at +603 2332 6000. or
email us at customersupport@alrajhibank.com.my.
<br /><br />
<b>
    Recording complaints
</b>
<br /><br />
When taking a complaint, we will record your name and contact details. We will also record all details of your complaint
including the facts and the cause/s of your complaint, the outcome and any actions taken following the investigation of
your complaint. We will also record all dates and times relating to actions taken to resolve the complaint and
communications between us.
<br />
As part of our on-going improvement plan, complaints will be monitored for any identifying trends by management and
rectification / remedial action taken to mitigate any identified issues.
<br /><br />
Where a business partner of the Bank is involved, we may be required to speak with them to fully investigate your
complaint.</p>
`,
  },
  {
    title: "<h1>Our Complaint <span>Handling Procedure</span></h1>",
    content: `
<p>
    alrajhi bank Malaysia is committed to resolving your issues at the first point of contact. However, this may not be possible in all circumstances, in which case a more formal complaints process will be followed.
    <br/><br/>
Our complaint handling procedure is as follows:
<br/><br/>
<img alt="news-image" src=${complaint_handling} width="100%"/>
    <br/>
    </p>

    `,
  },
  {
    title: "<h1>Further <span>Escalation</span></h1>",
    content: `
  <p>Where possible, we will attempt to resolve your complaint at the first point of contact. If we are unable to resolve your complaint at the first point of contact, we will undertake an investigation of your complaint and provide you with our findings.
    <br/><br/>
We understand that there could be instances where you may not be fully satisfied with how your complaint has been handled, or the resolution provided by us. You may seek to refer your case to the following redress channels:
<br/><br/>
<b>Bank Negara Malaysia: BNM</b>
<br/>
Tel: 1-300-88-5465 (1-300-88-LINK) <br/>
(Overseas: +603-2174 1717)
<br/>
Email: bnmtelelink@bnm.gov.my
<br/><br/>
<b>Financial Markets Ombudsman Services: FMOS</b>
<br/>
Tel: +603-2272 2811
<br/>
<a href="https://www.fmos.org.my/en/" target="_blank">https://www.fmos.org.my</a>
<br/><br/>
<b>Agensi Kaunseling Dan Pengurusan Kredit: AKPK</b>
<br/>
Tel: +603-2616 7799
<br/><br/>
</p>

    `,
  },
];
